import { http } from "@canvas/api";

export interface InventorySkuSearchReq {
  endpoint: "ragnarok.swatch.v1.inventory.sku.search";
  query: string;
}

export interface InventorySearchQuery {
  // limit: number | null ,
  // name__contains: string | null,
  // offset: number | null,
  // order_by: number | null
}

export interface InventorySkuSearchRes {
  error: string;
  response: {
    count: number;
    results: any[];
  };
}

export function get(
  req: InventorySkuSearchReq
): Promise<InventorySkuSearchRes> {
  return http
    .GET(`/ragnarok/swatch/v1/inventory/sku/search?${req.query}`)
    .then((response: InventorySkuSearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
